export const API_REQUEST_START = 'API_REQUEST_START';
export const API_REQUEST_END = 'API_REQUEST_END';
export const API_REQUEST_CANCELLED = 'API_REQUEST_CANCELLED';



// WEBPACK FOOTER //
// ./src/actionTypes/apiActionTypes.js